import { ClientError } from "graphql-request";
import { ErrorADT, safe } from "pb.safe";

import { $, mutation } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";

export async function getDeviceId({
	apiClient,
	deviceModel,
	deviceSerial,
}: {
	apiClient: ApiClient;
	deviceModel: string;
	deviceSerial: string;
}): Promise<string | ErrorADT<"OptionsInvalid" | "NetworkError">> {
	const response = await safe(() =>
		apiClient.request(getDeviceId.gql.getDeviceUuid, {
			model: deviceModel,
			serial: deviceSerial,
		}),
	);
	if (response instanceof Error) {
		if (response instanceof ClientError) {
			const isValidationError = response.response.errors?.some(
				(error) =>
					(error as unknown as Record<string, unknown>)["errorType"] ===
					"INPUT_VALIDATION_ERROR",
			);
			if (isValidationError) {
				return ErrorADT("OptionsInvalid");
			}
		}
		return ErrorADT("NetworkError");
	}

	const deviceId = response.getDeviceUuid.id;
	return deviceId;
}

getDeviceId.gql = {
	getDeviceUuid: mutation("getDeviceUuid", (q) => [
		q.getDeviceUuid(
			{ input: { model: $("model"), serial: $("serial") } },
			(c) => [c.id],
		),
	]),
};
